import { render, staticRenderFns } from "./CategoryCreateEdit.vue?vue&type=template&id=54c7e1fc&"
import script from "./CategoryCreateEdit.vue?vue&type=script&lang=js&"
export * from "./CategoryCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54c7e1fc')) {
      api.createRecord('54c7e1fc', component.options)
    } else {
      api.reload('54c7e1fc', component.options)
    }
    module.hot.accept("./CategoryCreateEdit.vue?vue&type=template&id=54c7e1fc&", function () {
      api.rerender('54c7e1fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/categories/CategoryCreateEdit.vue"
export default component.exports